import React, { useEffect, useState } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import { fetchRegisteredUsers } from '../../../pages/Services';
import TableContainer from '../../common/Tablecontainer'; 
import { gender as genderMapping, residence as residenceMapping } from '../../../constant/constants';

const RegisteredUsers = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () =>
            window.removeEventListener("resize", handleResize);
    }, []);
    
    // --- Pagination and Modal States ---
    const [isAddCourseModalOpen, setIsAddCourseModalOpen] = useState(false); 
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);     
    const [selectedUser, setSelectedUser] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecordsCount, setTotalRecordsCount] = useState(0); 

    // Modal state data holders
    const [masterCoursesList, setMasterCoursesList] = useState([]);
    const [loadingMasterCourses, setLoadingMasterCourses] = useState(false);
    
    // API State Data Holders
    const [profileUserDtls, setProfileUserDtls] = useState(null);
    const [profileCourseData, setProfileCourseData] = useState([]);
    const [profileEventDtls, setProfileEventDtls] = useState([]);

    // ─── 1. FETCH MASTER LIST FOR "ADD COURSE" (MODERN CARDS MATRIX) ───
    const openAddCourseModal = async (user) => {
        setSelectedUser(user);
        setMasterCoursesList([]); 
        setIsAddCourseModalOpen(true);
        setLoadingMasterCourses(true);
        
        try {
            const res = await API.get('getAllAmounts/');
            const formattedMasterCourses = res.data.map(c => ({
                id: c.amtId || c.amtid || c.id,
                name: c.AmtDesc || c.amtdesc || c.name || "N/A",
                amount: c.Amount !== undefined && c.Amount !== null ? c.Amount : (c.amount || "0.00"),
                duration: c.Duration || c.duration || "N/A"
            }));
            setMasterCoursesList(formattedMasterCourses);
        } catch (err) {
            console.error("Failed to load master courses list:", err);
        } finally {
            setLoadingMasterCourses(false);
        }
    };

    // ─── 2. ACTION: SUBMIT CASH TRANSACTION ───
    // ─── 💡 FIX: Existing Pending Entry Success  ───
    const handleAdminCourseActivation = async (course, refreshTableTrigger) => {
        if (!selectedUser) {
            toast.error("Error: No user selected.");
            return;
        }

        const userId = selectedUser.userid || selectedUser.userId;
        if (!userId) {
            toast.error("Error: User ID is missing in the selected user data.");
            return;
        }

        const confirmAction = window.confirm(`Confirm offline cash receipt and ACTIVATE course: ${course.name} for ${selectedUser.name}?`);
        if (!confirmAction) return;
        
        const payload = {
            userid: parseInt(userId, 10),               
            courseId: [parseInt(course.id, 10)],        
            txn_amount: parseFloat(course.amount || 0), 
            cust_id: selectedUser.emailid || selectedUser.emailId 
        };

        try {
            const token = localStorage.getItem('access_token');
            const res = await API.post('admin/activate-cash-course/', payload, {
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' 
                }
            });

            if (res.status === 200) {
                toast.success("Success! " + res.data.message);
                setIsAddCourseModalOpen(false); 
                // 🟢 Triggers self-contained reload logic inside table container natively
                if (refreshTableTrigger) refreshTableTrigger(); 
            }
        } catch (err) {
            console.error("Activation Error:", err.response?.data || err.message);
            const errorMsg = err.response?.data?.message || "Something went wrong!";
            toast.error("Activation failed: " + errorMsg);
        }
    };
    // ─── 3. CLICK USER NAME -> PROFILE OVERVIEW SUMMARY LAYER ───
    const triggerProfileSummaryView = async (user) => {
        setSelectedUser(user);
        const targetUserId = user.userid || user.userId;
        setLoading(true);
        try {
            const res = await API.get(`getAllUserDtlsById?userId=${targetUserId}`);
            setProfileUserDtls(res.data.userDtls);
            setProfileCourseData(res.data.courseData || []);
            setProfileEventDtls(res.data.EventDtls || []);
            setIsDetailsModalOpen(true);
        } catch (err) {
            console.error("Error invoking transaction logs summary API stream:", err);
        } finally {
            window.scrollTo(0, 0);
            setLoading(false);
        }
    };

    const loadUsers = async(page)=>{
        setLoading(true);

        try{

            const response =
            await fetchRegisteredUsers(
                page,
                searchQuery
            );

            setUsers(response.results);

            setTotalPages(
                Math.ceil(response.count/10)
            );

            setTotalRecordsCount(
                response.count
            );

        }
        finally{
            setLoading(false);
        }
    }

    useEffect(()=>{

        loadUsers(currentPage);

    },[
    currentPage,
    searchQuery
    ]);

    const tableHeaders = ['Name', 'Email', 'Contact', 'Residence', 'Gender', 'Action'];

    return (
        <div className="relative font-sans p-1 sm:p-2 md:p-4 select-none animate-fadeIn overflow-x-hidden">
            <div className="w-full text-center">
                    <h2 className="text-center text-xl sm:text-2xl md:text-4xl font-light text-gray-700 mb-4 tracking-tight">
                        Registered User
                    </h2>
            </div>
            <div className="w-full overflow-x-auto rounded-lg">
                <div className="mb-4">
                    <input
                        type="text"
                        placeholder="Search Name / Email / Mobile"
                        value={searchQuery}
                        onChange={(e)=>{
                            setSearchQuery(e.target.value);
                            setCurrentPage(1);
                        }}
                        className="w-full border rounded-lg p-3"
                    />
                </div>

            {
            isMobile ? (

                <>
                <div className="space-y-4">

                    {users.map((user, index) => (

                    <div
                        key={user.userid || index}
                        className="bg-white rounded-xl shadow-md border border-gray-200 p-4"
                    >

                        <div className="flex justify-between items-center mb-3">

                        <h3
                            onClick={() => triggerProfileSummaryView(user)}
                            className="font-bold text-[#032167] text-base underline cursor-pointer"
                        >
                            {user.name}
                        </h3>

                        <span className="text-xs font-bold text-gray-400">
                            #{(currentPage - 1) * 10 + index + 1}
                        </span>

                        </div>

                        <div className="space-y-2 text-sm">

                        <div>
                            <span className="font-semibold">Email:</span>
                            <p className="break-all text-gray-600">
                            {user.emailid}
                            </p>
                        </div>

                        <div>
                            <span className="font-semibold">Mobile:</span>
                            <span className="ml-2">
                            {user.mobileno || "-"}
                            </span>
                        </div>

                        <div>
                            <span className="font-semibold">Residence:</span>
                            <span className="ml-2">
                            {residenceMapping[user.residence] ||
                                user.residence ||
                                "N/A"}
                            </span>
                        </div>

                        <div>
                            <span className="font-semibold">Gender:</span>
                            <span className="ml-2">
                            {genderMapping[user.gender] ||
                                user.gender ||
                                "N/A"}
                            </span>
                        </div>

                        </div>

                        <button
                        type="button"
                        onClick={() => {
                            openAddCourseModal(user);
                            setSelectedUser(user);
                        }}
                        className="mt-4 w-full bg-[#032167] text-white py-3 rounded-lg font-bold uppercase text-xs hover:bg-blue-900 transition-all"
                        >
                        Add Course
                        </button>

                    </div>

                    ))}

                </div>

                {/* Pagination */}

                <div className="flex justify-center items-center gap-3 mt-6">

                    <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((p) => p - 1)}
                    className="px-4 py-2 rounded bg-[#032167] text-white disabled:bg-gray-300"
                    >
                    Previous
                    </button>

                    <span className="font-bold">
                    {currentPage} / {totalPages}
                    </span>

                    <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((p) => p + 1)}
                    className="px-4 py-2 rounded bg-[#032167] text-white disabled:bg-gray-300"
                    >
                    Next
                    </button>

                </div>

                </>

            ) : (
                

            
            <TableContainer
                columns={tableHeaders}
                apiUrl="admin/users/registered/"
                renderRow={(user, index, srNo, refreshTable) => (
                    <tr 
                        key={user.userid || index} 
                        className="border-b border-gray-200 hover:bg-slate-50/80 transition-colors h-[40px] text-gray-700 text-xs font-medium"
                    >
                        {/* 1. Serial Number */}
                        <td className="p-3 border-r bg-gray-50/50 font-bold text-gray-400 w-[6%] text-center">
                            {srNo}
                        </td>
                        
                        {/* 2. User Name (Clickable Profile) */}
                        <td 
                            onClick={() => triggerProfileSummaryView(user)} 
                            className="p-3 border-r text-left pl-6 font-bold uppercase text-blue-600 underline cursor-pointer hover:text-blue-900 tracking-wide w-[24%]"
                        >
                            {user.name}
                        </td>
                        
                        {/* 3. Email Address */}
                        <td className="min-w-[240px] break-all p-3 border-r text-left pl-4 font-mono text-[11px] text-gray-500 lowercase font-normal w-[25%]">
                            {user.emailid}
                        </td>
                        
                        {/* 4. Mobile Contact */}
                        <td className="p-3 border-r text-gray-600 w-[12%] text-center font-semibold">
                            {user.mobileno || '-'}
                        </td>
                        
                        {/* 5. Residence Status */}
                        <td className="p-3 border-r uppercase text-center font-semibold text-[#032167] w-[12%]">
                            {residenceMapping[user.residence] || user.residence || 'N/A'}
                        </td>
                        
                        {/* 6. Gender Group */}
                        <td className="p-3 border-r uppercase text-center font-bold text-gray-500 w-[10%]">
                            {genderMapping[user.gender] || user.gender || ' - '}
                        </td>
                        
                        {/* 7. Action Controller */}
                        <td className="min-w-[140px] p-3 text-center w-[11%]">
                            <button 
                                type="button" 
                                onClick={() => { 
                                    openAddCourseModal(user); 
                                    setSelectedUser({ ...user, refreshTableTrigger: refreshTable }); 
                                }} 
                                className="bg-[#032167] text-white px-3 py-1.5 rounded-md text-[10px] hover:bg-blue-950 border-none cursor-pointer font-bold uppercase tracking-wider shadow-sm transition-all active:scale-95"
                            >
                                Add Course
                            </button>
                        </td>
                    </tr>
                )}
            />
            )
            }
            </div>

            {/* ─── 💡 CREATIVE LAYOUT 1: ADD COURSE MODAL (MODERN GRID CARDS) ─── */}
            {isAddCourseModalOpen && selectedUser && (
                <div className="fixed inset-0 bg-slate-900/60 flex items-center justify-center z-[2000] p-4 backdrop-blur-md transition-all duration-300">
                    <div className="bg-[#F8FAFC] w-full max-w-[95vw]  rounded-xl shadow-2xl relative border border-gray-200 overflow-hidden flex flex-col h-[90vh] md:h-[85vh] animate-in zoom-in-95 duration-200">
                        {/* Header Banner */}
                        <div className="bg-[#032167] p-4 text-white flex items-center justify-between shadow-md">
                            <div className="flex flex-col text-left pl-4">
                                <h2 className="text-sm md:text-base font-bold uppercase tracking-widest">Assign Master Course Product</h2>
                                <p className="text-[11px] text-slate-300 font-medium">Activating subscription access node for: <span className="text-yellow-400 font-bold uppercase">{selectedUser.name}</span></p>
                            </div>
                            <button type="button" onClick={() => setIsAddCourseModalOpen(false)} className="text-slate-300 hover:text-white border-none bg-transparent text-2xl cursor-pointer font-bold transition-transform hover:scale-110 pr-2">×</button>
                        </div>

                        {/* Creative Content Body (Grid Cards Scrollable View) */}
                        <div className="p-6 overflow-y-auto flex-1 bg-slate-50/50">
                            {loadingMasterCourses ? (
                                <div className="h-full flex items-center justify-center font-semibold text-gray-400 uppercase tracking-widest animate-pulse">Syncing dynamic system product catalogs...</div>
                            ) : (
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                                    {masterCoursesList.map((course, idx) => (
                                        <div key={course.id || idx} className="bg-white border border-gray-200 hover:border-blue-400 rounded-lg p-5 flex flex-col justify-between shadow-xs hover:shadow-md transition-all duration-200 group relative overflow-hidden">
                                            {/* Ribbon Tag */}
                                            <div className="absolute top-0 right-0 bg-slate-100 text-slate-500 text-[9px] font-bold px-2.5 py-1 rounded-bl uppercase tracking-wide">
                                                ID: {course.id}
                                            </div>
                                            
                                            <div className="space-y-2 text-left">
                                                <div className="text-gray-400 text-[10px] font-bold uppercase tracking-wider">Product Segment {idx + 1}</div>
                                                <h3 className="text-xs md:text-sm font-bold break-words text-gray-800 tracking-tight line-clamp-2 uppercase min-h-[40px] group-hover:text-blue-700 transition-colors">
                                                    {course.name}
                                                </h3>
                                            </div>

                                            <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
                                                <div className="flex flex-col text-left">
                                                    <span className="text-[9px] font-bold text-gray-400 uppercase tracking-wider">Course Price</span>
                                                    <span className="text-lg font-black text-emerald-600">₹{course.amount}</span>
                                                </div>
                                                <div className="flex flex-col text-right">
                                                    <span className="text-[9px] font-bold text-gray-400 uppercase tracking-wider">Duration Limit</span>
                                                    <span className="text-xs font-bold text-slate-700 bg-slate-100 px-2 py-0.5 rounded-full mt-0.5">{course.duration} Days</span>
                                                </div>
                                            </div>

                                            <button 
                                                type="button" 
                                                onClick={() => handleAdminCourseActivation(course)}
                                                className="w-full mt-4 py-2 bg-slate-100 text-[#032167] group-hover:bg-[#032167] group-hover:text-white font-bold text-xs uppercase tracking-wider rounded-md border-none cursor-pointer transition-all shadow-xs active:scale-98"
                                            >
                                                Initialize Activation
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* ─── 💡 CREATIVE LAYOUT 2: USER COMPREHENSIVE OVERVIEW (IMAGE 2 & 3 SECTIONS LOG) ─── */}
            {isDetailsModalOpen && profileUserDtls && (
                <div className="fixed inset-0 bg-slate-900/60 flex items-center justify-center z-[3000] p-4 backdrop-blur-md overflow-y-auto transition-all duration-300">
                    <div className="bg-white w-full max-w-[95vw] md:max-w-3xl rounded-xl shadow-2xl overflow-hidden relative border border-gray-200 my-8 animate-in zoom-in-95 duration-200 flex flex-col">
                        {/* Header Title Grid Area */}
                        <div className="flex items-center justify-between p-4 border-b bg-slate-50">
                            <button type="button" onClick={() => setIsDetailsModalOpen(false)} className="absolute right-4 top-4 text-gray-400 hover:text-black border-none bg-transparent text-2xl cursor-pointer font-bold transition-colors">×</button>
                            <div className="flex-1 text-center">
                                <h3 className="text-xs font-black uppercase tracking-widest text-[#032167] border-b-2 border-blue-600 inline-block pb-1">User Comprehensive Summary</h3>
                            </div>
                        </div>

                        {/* Layout Content Body Box Grid */}
                        <div className="p-3 md:p-6 space-y-4 md:space-y-6 overflow-y-auto max-h-[75vh]">
                            
                            {/* Creative Profile Badge Presentation Layer */}
                            <div className="flex flex-col md:flex-row gap-6 items-center p-5 bg-gradient-to-r from-slate-50 to-blue-50/20 border border-slate-200 rounded-xl">
                                {/* Large Avatar Icon */}
                                <div className="w-16 h-16 bg-[#032167] text-white font-black text-2xl uppercase rounded-full flex items-center justify-center shadow-md border-2 border-white select-none">
                                    {profileUserDtls.Name.charAt(0)}
                                </div>
                                {/* Information Matrix Layout Fields Container */}
                                <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-3 text-xs font-semibold text-gray-600 w-full">
                                    <div className="flex justify-between border-b pb-1"><span>Full Name:</span><span className="text-gray-900 uppercase font-bold">{profileUserDtls.Name}</span></div>
                                    <div className="flex justify-between border-b pb-1"><span>Email Address:</span><span className="text-slate-800 font-mono text-[11px]">{profileUserDtls.emailId}</span></div>
                                    <div className="flex justify-between border-b pb-1"><span>Mobile Number:</span><span className="text-gray-900">{profileUserDtls.mobileno}</span></div>
                                    <div className="flex justify-between border-b pb-1"><span>Profile Location:</span><span className="text-gray-900 uppercase">{profileUserDtls.location}</span></div>
                                    <div className="flex justify-between border-b pb-1"><span>Residence Flag:</span><span className="text-indigo-900 uppercase font-bold">{profileUserDtls.residence}</span></div>
                                    <div className="flex justify-between border-b pb-1"><span>Gender Group:</span><span className="text-gray-800 font-bold">{profileUserDtls.gender}</span></div>
                                    <div className="flex justify-between border-b pb-1"><span>Date of Birth:</span><span className="text-gray-900">{profileUserDtls.dob}</span></div>
                                    <div className="flex justify-between border-b pb-1"><span>Registry Date:</span><span className="text-emerald-700 font-mono">{profileUserDtls.RegistrationDt}</span></div>
                                </div>
                            </div>

                            {/* Subscribed Active Courses Table Section Block */}
                            <div className="space-y-2">
                                <div className="text-left font-bold text-[10px] text-gray-400 uppercase tracking-widest pl-1">I. Registered Active Courses Database</div>
                                <div className="border border-gray-200 rounded-lg overflow-hidden shadow-xs">
                                    <div className="overflow-x-auto">
                                        <table className="min-w-[700px] w-full border-collapse text-[11px] text-center bg-white">
                                            <thead>
                                                <tr className="bg-slate-100 text-[#032167] font-bold border-b uppercase">
                                                    <th className="p-2.5 border-r w-[8%]">No.</th>
                                                    <th className="p-2.5 border-r text-left pl-4">Course Descriptor</th>
                                                    <th className="p-2.5 border-r">Price</th>
                                                    <th className="p-2.5 border-r">Duration</th>
                                                    <th className="p-2.5">Activation Stamp</th>
                                                </tr>
                                            </thead>
                                            <tbody className="font-semibold text-gray-700">
                                                {profileCourseData.length === 0 ? (
                                                    <tr><td colSpan="5" className="p-4 text-gray-400 font-medium bg-slate-50/30 uppercase tracking-wider">No Active Products Enrollment Logged.</td></tr>
                                                ) : (
                                                    profileCourseData.map((c, i) => (
                                                        <tr key={i} className="border-b last:border-none hover:bg-slate-50/60 transition-colors">
                                                            <td className="p-2.5 border-r font-bold text-gray-400 bg-gray-50/20">{i + 1}</td>
                                                            <td className="p-2.5 border-r text-left pl-4 uppercase font-bold text-slate-800">{c.courseName}</td>
                                                            <td className="p-2.5 border-r text-emerald-600 font-bold">₹{c.amount}</td>
                                                            <td className="p-2.5 border-r font-medium text-slate-600">{c.duration}</td>
                                                            <td className="p-2.5 text-indigo-950 font-mono text-[10px]">{c.activationDate}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {/* Registered Dynamic Events Summary List Table Block */}
                            <div className="space-y-2">
                                <div className="text-left font-bold text-[10px] text-gray-400 uppercase tracking-widest pl-1">II. Historical Event Packages Ledger</div>
                                <div className="border border-gray-200 rounded-lg overflow-hidden shadow-xs">
                                    <div className="overflow-x-auto">
                                    <table className="min-w-[700px] w-full border-collapse text-[11px] text-center bg-white">
                                        <thead>
                                            <tr className="bg-slate-100 text-teal-800 font-bold border-b uppercase">
                                                <th className="p-2.5 border-r w-[8%]">No.</th>
                                                <th className="p-2.5 border-r text-left pl-4">Target Celebration Event</th>
                                                <th className="p-2.5 border-r">Scheduled Date</th>
                                                <th className="p-2.5 border-r text-left pl-4">Operational Venue</th>
                                                <th className="p-2.5">Fees</th>
                                            </tr>
                                        </thead>
                                        <tbody className="font-semibold text-gray-700">
                                            {profileEventDtls.length === 0 ? (
                                                <tr><td colSpan="5" className="p-4 text-gray-400 font-medium bg-slate-50/30 uppercase tracking-wider">No Subscribed Event Attendance Found.</td></tr>
                                            ) : (
                                                profileEventDtls.map((e, i) => (
                                                    <tr key={i} className="border-b last:border-none hover:bg-slate-50/60 transition-colors">
                                                        <td className="p-2.5 border-r font-bold text-gray-400 bg-gray-50/20">{i + 1}</td>
                                                        <td className="p-2.5 border-r text-left pl-4 uppercase font-bold text-teal-700">{e.eventName}</td>
                                                        <td className="p-2.5 border-r font-mono text-[10px] text-gray-500">{e.frmDT} - {e.toDT}</td>
                                                        <td className="p-2.5 border-r text-left pl-4 uppercase text-slate-600 font-medium tracking-tight line-clamp-1">{e.venue}</td>
                                                        <td className="p-2.5 font-bold text-slate-900">₹{e.fees}</td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RegisteredUsers;